package br.com.texeratx.boardgametimeapp.ui.navigation

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.core.i18n.ProvideStrings
import br.com.texeratx.boardgametimeapp.ui.components.ActiveMatchMiniPlayer
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarHost
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarTone
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppSnackbarVisuals
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEvent
import br.com.texeratx.boardgametimeapp.ui.feedback.AppUiEventBus
import br.com.texeratx.boardgametimeapp.ui.screens.active_match.ActiveMatchScreen
import br.com.texeratx.boardgametimeapp.ui.screens.home.HomeScreen
import br.com.texeratx.boardgametimeapp.ui.screens.login.LoginScreen
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.MyClansScreen
import cafe.adriel.voyager.navigator.CurrentScreen
import cafe.adriel.voyager.navigator.Navigator
import org.koin.compose.getKoin

@Composable
fun AppNavigation() {
    val viewModel = getKoin().get<AppStartViewModel>()
    val languageManager = getKoin().get<LanguageManager>()
    val startDestination = viewModel.startDestination.collectAsState().value

    LaunchedEffect(Unit) { languageManager.init() }

    if (startDestination == null) {
        Text("Carregando...")
        return
    }

    val initialScreen = when (startDestination) {
        StartDestination.Login -> LoginScreen()
        StartDestination.MyClans -> MyClansScreen()
        StartDestination.Home -> HomeScreen()
    }

    ProvideStrings(languageManager) {
    Navigator(initialScreen) {
        val snackbarHostState = remember { SnackbarHostState() }

        LaunchedEffect(Unit) {
            AppUiEventBus.events.collect { event ->
                when (event) {
                    is AppUiEvent.SessionExpired -> {
                        it.replaceAll(LoginScreen())
                    }
                    is AppUiEvent.UiMessage -> snackbarHostState.showSnackbar(
                        AppSnackbarVisuals(
                            message = event.message,
                            tone = event.tone
                        )
                    )
                    is AppUiEvent.GameDeleted -> snackbarHostState.showSnackbar(
                        AppSnackbarVisuals(
                            message = event.message,
                            tone = AppSnackbarTone.Success
                        )
                    )
                    is AppUiEvent.PlayerDeleted -> snackbarHostState.showSnackbar(
                        AppSnackbarVisuals(
                            message = event.message,
                            tone = AppSnackbarTone.Success
                        )
                    )
                    AppUiEvent.ClanUpdated -> Unit
                }
            }
        }
        // ✅ Root container que permite desenhar "por cima" de qualquer tela
        Box(modifier = Modifier.fillMaxSize()) {

            // Tela atual
            CurrentScreen()
            AppSnackbarHost(
                hostState = snackbarHostState,
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(bottom = 84.dp)
            )

            // ✅ Mini player global, flutuando no rodapé
            // (fica bom em todas as telas, com ou sem BottomBar)
            val currentScreen = it.lastItem
            val isActiveMatchScreenOpen = currentScreen is ActiveMatchScreen
            val miniPlayerBottomPadding = if (currentScreen is HomeScreen) 120.dp else 12.dp
            if (!isActiveMatchScreenOpen) {
                ActiveMatchMiniPlayer(
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .padding(horizontal = 2.dp)
                        .padding(bottom = miniPlayerBottomPadding)
                )
            }
        }
    }
    } // ProvideStrings
}
